import { OrderState } from 'types/order';

export enum TabKey {
    PREPARE = 'PREPARE',
    DISTRIBUTE = 'DISTRIBUTE',
    DISTRIBUTED = 'DISTRIBUTED',
    CANCELLED = 'CANCELLED',
}
export type TabStatusType = { [key in TabKey]: OrderState[] };
